<script setup lang="js">
import { computed, nextTick } from 'vue';
import Multiselect from 'vue-multiselect';
import _ from 'lodash';

const props = defineProps({
  outputArgument: {
    type: Object,
    required: true
  },
  customVariables: {
    type: Array,
    required: true
  },
  createCustomVar: {
    type: Function,
    required: true
  }
});

const model = defineModel({ type: Object });

const typedVars = computed(() =>
  props.customVariables.filter((customVar) => {
    if (props.outputArgument.type !== 'array') {
      return props.outputArgument.type === customVar.type;
    }

    return !_.differenceBy(
      props.outputArgument?.columns,
      customVar?.table_columns,
      (c) => c?.name
    ).length;
  })
);

async function handleCreateCustomVar() {
  let varTitle = props.outputArgument.name;
  let counter = 1;

  const customVarObj = _.keyBy(props.customVariables, 'title');

  while (varTitle in customVarObj) {
    varTitle = `${props.outputArgument.name}_${counter++}`;
  }

  const variableProps = {
    title: varTitle,
    type: props.outputArgument.type
  };

  if (props.outputArgument.type === 'array') {
    variableProps.table_columns = _.values(props.outputArgument.columns).map((i) => ({ ...i }));
  }
  if (props.outputArgument.type === 'text') {
    variableProps.default_value = ' ';
  }

  props.createCustomVar(variableProps);

  await nextTick();

  model.value = props.customVariables.find(cv => cv.title === varTitle);
}
</script>

<template>
  <div class="d-flex justify-content-between">
    <label class="form-label flex-shrink-0">
      {{ props.outputArgument.title }} [{{ props.outputArgument.type }}]
    </label>
    <div class="add-btn mb-2 flex-shrink-0">
      <img @click="handleCreateCustomVar" src="@/assets/img/plus-ico.svg" />
    </div>
  </div>
  <Multiselect
    v-model="model"
    :options="typedVars"
    placeholder="Выбрать..."
    :multiple="false"
    label="title"
    track-by="name"
    class="multiselect-style"
  />
</template>
